import { jsx as _jsx } from "react/jsx-runtime";
import GuideLayout, { GuideSection } from '../../components/GuideLayout/GuideLayout';
import { P, RowsFrom } from '../../components/GuideLayout/content';
const GlossaryGuidePage = () => (_jsx(GuideLayout, { route: "/guides/glossary", lead: _jsx(P, { k: "g.glossary.lead" }), children: _jsx(GuideSection, { id: "terms", children: _jsx(RowsFrom, { k: "g.glossary.terms" }) }) }));
export default GlossaryGuidePage;
